<template>
  <v-row>
    <v-dialog v-model.sync="contentDeclarationDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>        
        <v-toolbar fixed>
          <v-btn icon @click="$store.dispatch('setContentDeclarationDialog', false)">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Declaração de conteúdo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="print" fixed right fab dark color="indigo">
            <v-icon dark>print</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="pdfDeclaration" ref="pdfContent">
          <div v-for="t in transactions" :key="t.id" style="{width: '99%', position: 'relative', margin: '0 auto'}">
            <img src="../assets/correios.png"/>
            <p>
              Declaração de Conteúdo
            </p>
            <table>
              <tbody>
                <tr>
                  <td className="half">
                    <table>
                      <tbody>
                        <tr><td colspan="2" contentEditable="true">REMETENTE: Rodrigo Gonçalves</td></tr>
                        <tr><td colspan="2" contentEditable="true">CPF: 01480403090</td></tr>
                        <tr><td colspan="2" contentEditable="true">ENDEREÇO: Avenida Freitas Vale, 20</td></tr>
                        <tr>
                          <td style="width: 70%" contentEditable="true">CIDADE/UF: Alegrete/RS</td>
                          <td style="width: 30%" contentEditable="true">CEP: 97541-230</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className="half">
                    <table>
                      <tbody>
                        <tr>
                          <td colspan="2" contentEditable="true">DESTINATÁRIO: {{t.customer && t.customer.name}}
                          </td>
                        </tr>
                        <tr><td colspan="2" contentEditable="true">CEP: {{
                            t.customer && t.customer.address && t.customer.address.postal_code
                          }}
                        </td></tr>
                        <tr>
                          <td colspan="2" contentEditable="true">
                            ENDEREÇO: 
                            {{t.customer && t.customer.address && t.customer.address.address }},
                            {{t.customer && t.customer.address && t.customer.address.number}}
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 70%" contentEditable="true">
                            CIDADE/UF: {{
                              t.customer && t.customer.address && t.customer.address.city.name
                            }}/{{
                              t.customer && t.customer.address && t.customer.address.city.state.name
                            }}
                          </td>
                          <td style="width: 30%" contentEditable="true">CEP: {{
                              t.customer && t.customer.address && t.customer.address.postal_code
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <br/>
            <table>
              <tbody>
                <tr className="text-center" contentEditable="true"><td colspan="3">IDENTIFICAÇÃO DOS BENS</td></tr>
                <tr className="text-center">
                  <td style="width: 70%" contentEditable="true"> DISCRIMINAÇÃO DO CONTEÚDO</td>
                  <td style="width: 70%" contentEditable="true"> QUANTIDADE</td>
                  <td>PESO</td>
                </tr>
                <tr>
                  <td contentEditable="true">{{t.store.name}}</td>
                  <td contentEditable="true">{{t.qnt}}</td>
                  <td></td>
                </tr>                   
                <tr className="text-center">
                  <td colspan="2" contentEditable="true">
                    VALOR TOTAL
                  </td> 
                  <td></td>
                </tr>
              </tbody>
            </table>
            <br/>
            <table>
              <tbody>
                <tr id="declaracao" className="text-center">
                  <td contentEditable="true">DECLARAÇÃO</td>
                </tr>
                <tr>
                  <td>
                    <p contentEditable="true">Declaro, não ser pessoa física ou jurídica, que realize, com habitualidade ou em volume que caracterize intuito comercial, operações de circulação de mercadoria, ainda que estas se iniciem no exterior, que o conteúdo declarado e não está sujeito à tributação, e que sou o único responsável por eventuais penalidades ou danos decorrentes de informações inverídicas</p>
                    <p contentEditable="true">Alegrete {{now}}</p>
                    <p>
                      <span id="remetente-ass" contentEditable="true">Assinatura do Declarante Remetente</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br/>
            <table>
              <tbody>
                <tr id="atencao">
                  <td contentEditable="true"><strong>Atenção: </strong>O declarante/remetente é responsável exclusivamente pelas informações declaradas.</td>
                </tr>
                <tr>
                  <td>
                    <p><strong>OBSERVAÇÕES:</strong></p>                          
                    <ul contentEditable="true">
                      <li>
                        É Contribuinte de ICMS qualquer pessoa física ou jurídica, que realize, com habitualidade ou em volume que caracterize intuito comercial,
                        operações de circulação de mercadoria ou prestações de serviços de transportes interestadual e intermunicipal e de comunicação, ainda
                        que as operações e prestações se iniciem no exterior (Lei Complementar no 87/96 Art. 4o).
                      </li>
                      <li>
                        Constitui crime contra a ordem tributária suprimir ou reduzir tributo, ou contribuição social e qualquer acessório: quando negar ou deixar
                        de fornecer, quando obrigatório, nota fiscal ou documento equivalente, relativa a venda de mercadoria ou prestação de serviço,
                        efetivamente realizada, ou fornecê-la em desacordo com a legislação. Sob pena de reclusão de 2 (dois) a 5 (anos), e multa (Lei 8.137/90
                        Art. 1o, V).
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
            <br/>
            <div id="importante" contentEditable="true">
              <p><strong>Importante:</strong></p>
              <p>A pedido dos Correios, as encomendas terão que ter, conforme corresponda, uma nota fiscal ou declaração de conteúdos colada na sua parte
              externa com uma proteção transparente.</p>
            </div>
          </div>
        </div>
      )
    })
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment';
  export default {
    data () {
      return {  
        now: moment().format('DD/MM/YYYY'),
      }
    },
    methods: {
      print() {
        if (window) {
          const divContents = document.getElementById('pdfDeclaration').innerHTML;
          const params = [
              'height='+screen.height,
              'width='+screen.width,
              'fullscreen=yes' // only works in IE, but here for completeness
          ].join(',');
          var printWindow = window.open('', '', params);
          printWindow.document.write('<html><head><link rel="stylesheet" href="https://easytools.com.br/css/declaracao.css"></head><body >');                
          printWindow.document.write(divContents);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          const time_hndlr = setTimeout(() => {
            printWindow.print();
            clearTimeout(time_hndlr);
          }, 1500);
        }
      }
    },
    computed: {
      contentDeclarationDialog: {
        get() {
          return this.$store.state.contentDeclarationDialog;
        },
        set(value) {          
          this.$store.commit('setContentDeclarationDialog', value);
        }
      },
      transactions () {
        return this.$store.state.transactions.data.filter(t => t.customer.address && true);
      }
    }
  }
</script>
<style scoped>
#pdfDeclaration{
padding-top: 100px;
margin: 0;
font-size: 8pt;
position:relative;
}
#pdfDeclaration > div {
position: relative;
}
img {
float: left;
}
.half {
width: 50%;
}
.text-center {
text-align: center;
}
* {
box-sizing: border-box;
}
ul {
list-style-type: upper-roman;
}
#pdfDeclaration > div > p {
padding-bottom: 40px;
border-bottom: 1px solid #000;
max-width: 400px;
margin: 20px auto;
text-align: center;
font-weight: bold;
font-size:12pt;
}
#pdfDeclaration > div {
page-break-before: auto;
page-break-after: always;
}
#pdfDeclaration > div > table {  
margin: 0 auto;
border: 1px solid #000;
border-spacing: 0;
border-collapse: collapse;
width: 100%;
}
@media print {
#pdfDeclaration > div {
page-break-before: auto;
page-break-after: always; 
}
#pdfDeclaration > div > table { 
margin: 0 auto;
border: 1px solid #000;
border-spacing: 0;
border-collapse: collapse;
font-size: 8pt; 
width: 100%;  
}
}
td > table {
width: 100%;
}
td {
font-size: 8pt;
border-bottom: 1px solid #000;
min-height: 10px;
}
tr > td {
border-right: 1px solid #000;
}
#declaracao {
background-color: #dedede
}
#remetente-ass {
border-top: 1px solid #000;
padding: 2px;
float: right;
}
#importante {
border: 2px solid #ddd;
padding: 2px;
}
</style>